import { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

import { Box } from '@mui/material'
import request from 'api'
import { Container } from 'components'
import { Loading } from 'components/ui'
import { useMappedTranslation } from 'hooks'
import Detail from 'pages/policies/views/detail'
import { convertCountryCode2to3, countryCode, getLangugageByCountry, languageCode } from 'utils/i18n'

export default function SpecialTerms() {
  const { filename } = useParams()
  const [searchParams] = useSearchParams()
  const t = useMappedTranslation()
  const [detail, setDetail] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const countryCodeParam = searchParams.get('countryCode')

  const getLocale = () => {
    let countryCode3 = countryCode,
      languageCode3 = languageCode
    if (countryCodeParam) {
      countryCode3 = convertCountryCode2to3(countryCodeParam)
      languageCode3 = getLangugageByCountry(countryCode3)
    }

    return [
      [countryCode3, languageCode3],
      [countryCode3, 'default'],
      ['global', languageCode3],
      ['global', 'default']
    ]
  }

  const getLegalContent = async () => {
    const caseList = getLocale()

    const getContent = (url) =>
      request
        .get(url, { headers: { 'Content-Type': 'text/plain; charset=UTF-8' }, responseType: 'text' })
        .then((res) => res)
        .catch((e) => {
          return { status: e.status, data: null }
        })
    const promises = caseList.map((item) =>
      getContent(`${process.env.REACT_APP_EULA_URL}/contents/legal/${item[0].toLowerCase()}/${item[1]}/${filename}`)
    )
    for (const promise of promises) {
      try {
        const response = await promise

        if (response.status === 200) {
          setDetail(response.data)
          setIsLoading(false)
          return true
        }
      } catch (error) {
        setDetail('<div>Failed to Load</div>')
      }
    }

    return false
  }

  useEffect(() => {
    getLegalContent().then((res) => {
      if (!res) {
        setIsLoading(false)
        setDetail('<div>Failed to Load</div>')
      }
    })
  }, [])

  return (
    <Box sx={{ width: '100%', height: '100%', mt: { lg: '46px' } }}>
      {isLoading ? (
        <Loading fullScreen={true} />
      ) : (
        <Container sx={{ padding: { lg: '0', xs: '0 24px' } }}>
          <Detail title={t('iam.membership.head.title.MoreTerms')} isLoading={isLoading} detail={detail} />
        </Container>
      )}
    </Box>
  )
}
